import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("tt_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("tt_admin_token");
      localStorage.removeItem("tt_admin_user");
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const api = {
  login: (email, password) => client.post("/admin/auth/login", { email, password }),
  me: () => client.get("/admin/auth/me"),
  logout: () => client.post("/admin/auth/logout"),
  dashboard: () => client.get("/admin/dashboard"),
  listLeads: (params = {}) => client.get("/admin/leads", { params }),
  getLead: (id) => client.get(`/admin/leads/${id}`),
  createLead: (data) => client.post("/admin/leads", data),
  updateLead: (id, data) => client.patch(`/admin/leads/${id}`, data),
  deleteLead: (id) => client.delete(`/admin/leads/${id}`),
  draftEmail: (id, payload) => client.post(`/admin/leads/${id}/draft-email`, payload),
  approveEmail: (id, payload) => client.post(`/admin/leads/${id}/approve-email`, payload),
  listOutbound: (status) => client.get("/admin/outbound", { params: status ? { status } : {} }),
  cancelOutbound: (id) => client.post(`/admin/outbound/${id}/cancel`),
  addActivity: (id, data) => client.post(`/admin/leads/${id}/activities`, { ...data, lead_id: id }),
  listSources: () => client.get("/admin/sources"),
  listFreightQuotes: (status) => client.get("/admin/freight-quotes", { params: status ? { status } : {} }),
  getFreightQuote: (id) => client.get(`/admin/freight-quotes/${id}`),
  updateFreightQuote: (id, data) => client.patch(`/admin/freight-quotes/${id}`, data),
  convertFreightQuoteToLead: (id) => client.post(`/admin/freight-quotes/${id}/convert-to-lead`),
  listMerchants: () => client.get("/admin/merchants"),
  createMerchant: (data) => client.post("/admin/merchants", data),
  updateMerchant: (id, data) => client.patch(`/admin/merchants/${id}`, data),
  deleteMerchant: (id) => client.delete(`/admin/merchants/${id}`),
  merchantSla: (id) => client.get(`/admin/merchants/${id}/sla`),
  merchantShipments: (id) => client.get(`/admin/merchants/${id}/shipments`),
  seedDemoShipments: (id) => client.post(`/admin/merchants/${id}/seed-demo-shipments`),
  listHubs: () => client.get("/admin/hubs"),
  updateHub: (slug, data) => client.patch(`/admin/hubs/${slug}`, data),
  apolloStatus: () => client.get("/admin/apollo/status"),
  importApollo: (data) => client.post("/admin/leads/import-apollo", data),
  importCsv: (source, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post(`/admin/leads/import-csv?source=${encodeURIComponent(source)}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export default client;
